<template>
  <div class="video-format">
    <h2 class="format-title">键盘快捷方式</h2>
    <a-table
      :columns="columns"
      :dataSource="list"
      :pagination="false"
      class="keyboard-shortcut-table"
    ></a-table>
    <p>提示: MacOS 系统请将 Ctrl 替换成 Command.</p>
  </div>
</template>

<script>
export default {
  name: "VideoFormat",
  data: function () {
    return {
      list: [
        {
          cmd: '剪切',
          key: 'Ctrl+X',
          display: 'Ctrl+X'
        },
        {
          cmd: '复制',
          key: 'Ctrl+C',
          display: 'Ctrl+C'
        },
        {
          cmd: '粘贴',
          key: 'Ctrl+V',
          display: 'Ctrl+V'
        },
        {
          cmd: '撤销',
          key: 'Ctrl+Z',
          display: 'Ctrl+Z'
        },
        {
          cmd: '恢复',
          key: 'Ctrl+Y',
          display: 'Ctrl+Y'
        },
        {
          cmd: '全选',
          key: 'Ctrl+A',
          display: 'Ctrl+A'
        },
        {
          cmd: '保存',
          key: 'Ctrl+S',
          display: 'Ctrl+S'
        },
        {
          cmd: '选择多项',
          key: 'Ctrl+MouseDown',
          display: 'Ctrl+鼠标左键'
        },
        {
          cmd: '组合',
          key: 'Ctrl+G',
          display: 'Ctrl+G'
        },
        {
          cmd: '删除',
          key: 'Del',
          display: 'Del'
        },
        {
          cmd: '片段预览',
          key: 'Space',
          display: '空格键'
        },
        {
          cmd: '显示网格',
          key: "Ctrl+'",
          display: "Ctrl+'"
        },
        {
          cmd: '画板放大',
          key: 'Ctrl+WheelUp',
          display: 'Ctrl+滚轮向上'
        },
        {
          cmd: '画板缩小',
          key: 'Ctrl+WheelDown',
          display: 'Ctrl+滚轮向下'
        },
        {
          cmd: '时间轴放大',
          key: 'Alt+WheelUp',
          display: 'Alt+滚轮向上'
        },
        {
          cmd: '时间轴缩小',
          key: 'Alt+WheelDown',
          display: 'Alt+滚轮向下'
        },
        {
          cmd: '向上移动',
          key: 'UpArrow',
          display: '上箭头'
        },
        {
          cmd: '向下移动',
          key: 'DownArrow',
          display: '下箭头'
        },
        {
          cmd: '向左移动',
          key: 'LeftArrow',
          display: '左箭头'
        },
        {
          cmd: '向右移动',
          key: 'RightArrow',
          display: '右箭头'
        },
        {
          cmd: '剪辑',
          key: 'c',
          display: 'C'
        },
        {
          cmd: '图片替换',
          key: 'Ctrl+D',
          display: 'Ctrl+D'
        }
      ],
      columns: [
        {
          title: '操作',
          dataIndex: 'cmd',
          width: '4%'
        },
        {
          title: '键盘绑定',
          dataIndex: 'display',
          width: '5%'
        }
      ]
    };
  },
  watch: {

  }
}
</script>

<style scoped>
.video-format {
  background: rgba(248, 248, 248, 1);
  padding: 12px 16px;
  box-sizing: border-box;
}

.format-title {
  font-size: 14px;
  font-weight: 400;
  /* color: rgba(101, 102, 103, 1); */
  margin: 0;
}

.keyboard-shortcut-table {
  margin: 12px 0;
}

.keyboard-shortcut-table ::v-deep col {
  width: 1%;
}

.keyboard-shortcut-table ::v-deep .ant-table-thead > tr > th {
  background-color: transparent;
  border-radius: 0;
}

.keyboard-shortcut-table ::v-deep .ant-table-thead > tr > th,
.keyboard-shortcut-table ::v-deep .ant-table-tbody > tr > td {
  padding: 4px 12px;
}

.keyboard-shortcut-table ::v-deep .ant-table-tbody > tr > td {
  border-bottom: 0;
}
.keyboard-shortcut-table ::v-deep .ant-table-tbody > tr:nth-child(2n) > td {
  background-color: rgba(0, 0, 0, 0.04);
}
.keyboard-shortcut-table
  ::v-deep
  .ant-table-tbody
  > tr.ant-table-row-hover:not(.ant-table-expanded-row):not(.ant-table-row-selected)
  > td,
.keyboard-shortcut-table
  ::v-deep
  .ant-table-tbody
  > tr:hover:not(.ant-table-expanded-row):not(.ant-table-row-selected)
  > td,
.keyboard-shortcut-table
  ::v-deep
  .ant-table-thead
  > tr.ant-table-row-hover:not(.ant-table-expanded-row):not(.ant-table-row-selected)
  > td,
.keyboard-shortcut-table
  ::v-deep
  .ant-table-thead
  > tr:hover:not(.ant-table-expanded-row):not(.ant-table-row-selected)
  > td {
  background-color: rgba(0, 0, 0, 0.06);
}

/* .keyboard-shortcut-helps {
  padding-left: 16px;
}

.keyboard-shortcut-helps__item {
  padding-left: 2px;
  margin-bottom: 4px;
} */
</style>
